import { render, staticRenderFns } from "./AsoSection.vue?vue&type=template&id=0f3d661f&scoped=true"
import script from "./AsoSection.vue?vue&type=script&lang=js"
export * from "./AsoSection.vue?vue&type=script&lang=js"
import style0 from "./AsoSection.vue?vue&type=style&index=0&id=0f3d661f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3d661f",
  null
  
)

export default component.exports